import React from "react";
import "./newText.scss"
type Props = {
  newtext: string;
};

const NewText = ({ newtext }: Props) => {
  return (
    <div className="newText">
      <span>
       {newtext}
      </span>
    </div>
  );
}

export default NewText;